// extracted by mini-css-extract-plugin
module.exports = {"Canvas":"Settings_Canvas__3qNDD","Settings":"Settings_Settings__25I57","Cam":"Settings_Cam__2rLtv"};